export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-chat-3-line text-white text-base"></i>
              </div>
              <span className="font-heading text-lg font-bold text-white">吃瓜在线</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              吃瓜在线是整合51吃瓜在线、91吃瓜在线、17吃瓜在线等多平台入口的综合性娱乐资讯聚合站点，致力于为全网用户提供最新、最快、最全的八卦与娱乐内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">快捷入口</h4>
            <ul className="space-y-2.5">
              <li><a href="#cards" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热门速递</a></li>
              <li><a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a></li>
              <li><a href="#index" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">专题索引</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a></li>
              <li><a href="#updates" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">热门话题</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-300">明星八卦</span></li>
              <li><span className="text-sm text-foreground-300">综艺热点</span></li>
              <li><span className="text-sm text-foreground-300">影视资讯</span></li>
              <li><span className="text-sm text-foreground-300">音乐动态</span></li>
              <li><span className="text-sm text-foreground-300">网红生态</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              敬请期待更多合作伙伴加入。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 rounded-lg bg-foreground-700 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-mail-line text-white text-sm"></i>
              </a>
              <div className="w-9 h-9 rounded-lg bg-foreground-700 flex items-center justify-center cursor-pointer">
                <i className="ri-wechat-line text-white text-sm"></i>
              </div>
              <div className="w-9 h-9 rounded-lg bg-foreground-700 flex items-center justify-center cursor-pointer">
                <i className="ri-weibo-line text-white text-sm"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 吃瓜在线. All Rights Reserved.
          </p>
          <p className="text-xs text-foreground-400">
            51吃瓜在线 · 91吃瓜在线 · 17吃瓜在线 · 51吃瓜网在线 — 官方入口聚合平台
          </p>
        </div>
      </div>
    </footer>
  );
}